import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllAccount() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllAccountPagination(page, limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?page=${page}&limit=${limit}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllAccountSearch(search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllAccountPaginationSearch(page, limit, search) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountsByReportingUsers?page=${page}&limit=${limit}&search=${search}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllAccountType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllAccountType`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllOwnership() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllOwnership`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchAllCustomerstatus() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllCustomerStatus`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getOwnerChange(userId, accountId) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/checkAccountIsInGoals/${userId}/${accountId}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanyAccount() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllAccountsByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchAccountDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getByAccountsId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AccountScoreData(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAccountScoreByAccountId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AccountsByAccountType() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllAccountsByAccountType`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function AccountConnectioncheck(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/findAccountConnections`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AccountMergerUpadet(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAccountsInMerge/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function mergeAccountDelte(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/deleteAccountInMerge`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massUpdateAccount(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/massUpdateAccount`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function massDeleteAccount(payload) {
    try {
        const response = await getAxiosInstance().delete(`/usermgmt/massDeleteAccount`, { headers, data: payload })
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createAccounts(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createAccounts`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateAccounts(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateAccounts/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    massDeleteAccount,
    massUpdateAccount,
    FetchAllAccount,
    FetchAllAccountType,
    FetchAllOwnership,
    getOwnerChange,
    FetchAllCustomerstatus,
    getCompanyAccount,
    FetchAccountDetails,
    AccountScoreData,
    AllAccountPagination,
    AllAccountPaginationSearch,
    FetchAllAccountSearch,
    AccountConnectioncheck,
    mergeAccountDelte,
    AccountMergerUpadet,
    AccountsByAccountType,
    updateAccounts,
    createAccounts
}